(function () {
  try {
    const body = document.body;
    const isPdpTemplate = body && body.classList
      ? (body.classList.contains('template-product') || [...body.classList].some(className => className.startsWith('template-product')))
      : false;

    if (!isPdpTemplate && window.dAgency && typeof window.dAgency.initCarouselBanner === 'function' && !window.dAgency.__carouselBannerIgnoreIndex) {
      const originalInit = window.dAgency.initCarouselBanner;
      window.dAgency.initCarouselBanner = function (root) {
        return originalInit(root);
      };
      window.dAgency.__carouselBannerIgnoreIndex = true;
    }
  } catch (e) {
    // no-op
  }
})();

document.addEventListener("DOMContentLoaded", (event) => {

  let isMobile = false;

  // Set CSS custom property for viewport height (fallback for older browsers)
  function setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  
  setViewportHeight();
  window.addEventListener('resize', setViewportHeight);
  window.addEventListener('orientationchange', setViewportHeight);
  
  const body = document.body;
  const templates = [
    'template-index',
    'template-page-concierge-service',
    'template-page-journal-all',
    'template-collection-shop-by-look',
    'template-page-ski_kit_donna',
    'template-page-ski-kit-uomo',
    'template-page-walter-bonatti',
    'template-page-carbon-cashmere',
    'template-page-solaro_new',
    'template-page-safari_kit_seasexamos'
  ];
  const hasMatchingClass = [...body.classList].some(className => 
    className.startsWith('template-page-editoriale') || 
    className.startsWith('template-page-chapter')
  );
  const isAlwaysWhitePage = hasMatchingClass || templates.some(cls => body.classList.contains(cls));
  if (isAlwaysWhitePage) {
    document.body.classList.add('header-white');
  }
  const hasMatchingClass4PermanentWhite = [...body.classList].some(className => 
    className.startsWith('template-page-ski_kit_donna') || 
    className.startsWith('template-page-ski-kit-uomo') || 
    className.startsWith('template-index') || 
    className.startsWith('template-page-solaro_new') || 
    className.startsWith('template-page-safari_kit_seasexamos')
  );
  if( hasMatchingClass4PermanentWhite ) {
    document.body.classList.add('permanent-white');
  }
  
  window.addEventListener('resize', () => {

    isMobile = (window.matchMedia("(max-width:1024px)").matches) ? true : false;
    window.dispatchEvent(new Event('scroll'));
  });
  window.dispatchEvent(new Event('resize'));

  // Sticky header
  let lastScrollTop = 0;
  const siteHeader = document.querySelector('#header-announcement-container');
  const siteContent = document.querySelector('#PageContainer');

  function handleScroll() {

    let currentScroll = document.documentElement.scrollTop || 
       document.body.scrollTop || 
       window.pageYOffset || 
       0;
    let windowHeight = window.innerHeight;
    let documentHeight = document.documentElement.scrollHeight;
    const scrollPaddingTop = getComputedStyle(document.documentElement).getPropertyValue('scroll-padding-top');
    const headerHeight = parseInt(scrollPaddingTop, 10);
    let targetH = windowHeight - (headerHeight/2.2);
    
    // console.log('headerHeight app: ', headerHeight)

    let maxScrollOffset = isMobile ? 55 : 80;
    let offset = Math.min(headerHeight, maxScrollOffset);
    document.documentElement.style.setProperty('--scroll-offset', offset + 'px');

    if (hasMatchingClass || templates.some(cls => body.classList.contains(cls))) {
      if( currentScroll > targetH ) {
        if (!document.body.classList.contains('permanent-white')) {
          document.body.classList.remove('header-white');
        }
      } else {
        document.body.classList.add('header-white');
      }
    }
    
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }

  let scrollTimeout;
  function throttleScroll() {
    clearTimeout(scrollTimeout);
    const isCollectionPage = document.body.classList.contains('template-collection');
    const delay = isCollectionPage ? 200 : 200;
    scrollTimeout = setTimeout(handleScroll, delay);
  }

  window.addEventListener('scroll', throttleScroll, { passive: true });
  window.dispatchEvent(new Event('scroll')); // Initial check

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      handleScroll();
    }, 100);
  });

  const isPdpTemplate = body && body.classList
    ? (body.classList.contains('template-product') || [...body.classList].some(className => className.startsWith('template-product')))
    : false;

  if (isPdpTemplate && window.dAgency && typeof window.EmblaCarousel !== 'undefined') {
    window.dAgency.initCarouselBanner = function (root) {
      if (!root) return;

      function parseBoolean(value) {
        if (value === undefined || value === null || value === '') return null;
        var normalized = String(value).toLowerCase();
        if (['true', '1', 'yes', 'on'].indexOf(normalized) !== -1) return true;
        if (['false', '0', 'no', 'off', 'none', 'hide'].indexOf(normalized) !== -1) return false;
        return null;
      }

      function applySlideSizing(container, slides) {
        if (!container || !slides || !slides.length) return;
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (
          isMobile &&
          document.body &&
          document.body.id === 'carbon-cashmere' &&
          container.closest &&
          container.closest('.products-slider__container')
        ) {
          container.dataset.emblaSlidesMobile = '2';
        }
        var slidesDesktop = parseFloat(container.dataset.emblaSlidesDesktop || '');
        var slidesMobile = parseFloat(container.dataset.emblaSlidesMobile || '');
        var perView = isMobile ? slidesMobile : slidesDesktop;
        if (!perView || Number.isNaN(perView)) {
          container.style.removeProperty('--embla-slide-size');
          slides.forEach(function (slide) {
            slide.style.flex = '';
            slide.style.width = '';
            slide.style.maxWidth = '';
          });
          return null;
        }

        var size = (100 / perView) + '%';
        container.style.setProperty('--embla-slide-size', size);
        slides.forEach(function (slide) {
          slide.style.flex = '0 0 ' + size;
          slide.style.width = size;
          slide.style.maxWidth = size;
        });
        
        return perView;
      }

      var containers = [];
      if (root.classList && root.classList.contains('carousel-banner__swiper-container')) {
        containers = [root];
      } else {
        containers = Array.prototype.slice.call(root.querySelectorAll('.carousel-banner__swiper-container'));
      }

      if (!containers.length) return;

      containers.forEach(function (container) {
        var scope = container.closest('.carousel-banner__container') || container.closest('.shopify-section') || container;
        var viewport = container.querySelector('.embla__viewport');
        if (!viewport) return;

        if (container._embla && typeof container._embla.destroy === 'function') {
          container._embla.destroy();
        }

        var slides = Array.prototype.slice.call(container.querySelectorAll('.embla__slide'));
        var controlsSetting = parseBoolean(container.dataset.emblaControls);
        var loopSetting = parseBoolean(container.dataset.emblaLoop);
        var dragFreeSetting = parseBoolean(container.dataset.emblaDragFree);
        var arrowsWrap = scope.querySelector('.carousel-banner__arrow');
        var prevEl = scope.querySelector('.swiper-button-prev');
        var nextEl = scope.querySelector('.swiper-button-next');

        if (controlsSetting === false && arrowsWrap) {
          arrowsWrap.style.display = 'none';
          prevEl = null;
          nextEl = null;
        } else if (arrowsWrap) {
          arrowsWrap.style.display = '';
        }

        var perView = applySlideSizing(container, slides);

        var shouldLoop = loopSetting === null
          ? (perView ? slides.length > perView : slides.length > 4)
          : loopSetting;
        var shouldDragFree = dragFreeSetting === null ? true : dragFreeSetting;
        var embla = window.EmblaCarousel(viewport, {
          align: 'start',
          loop: shouldLoop,
          dragFree: shouldDragFree,
          containScroll: shouldLoop ? false : 'trimSnaps',
          skipSnaps: shouldDragFree
        });
        container._embla = embla;
        container._emblaLoop = shouldLoop;
        container._emblaDragFree = shouldDragFree;
        container._emblaPerView = perView;

        function safeReInit() {
          if (!container._embla || typeof container._embla.reInit !== 'function') return;
          try {
            container._embla.reInit();
          } catch (e) {
            // no-op
          }
        }

        // Prevent initial "shift" by re-measuring after layout/images settle.
        if (!container._emblaInitialReinitQueued) {
          container._emblaInitialReinitQueued = true;
          requestAnimationFrame(function () {
            requestAnimationFrame(safeReInit);
          });

          window.addEventListener('load', safeReInit);

          var imgs = container.querySelectorAll('img');
          if (imgs && imgs.length) {
            Array.prototype.slice.call(imgs).forEach(function (img) {
              if (!img) return;
              if (img.complete) return;
              img.addEventListener('load', safeReInit, { once: true });
              img.addEventListener('error', safeReInit, { once: true });
            });
          }
        }

        if (prevEl) {
          prevEl.onclick = function () {
            if (container._embla) container._embla.scrollPrev();
          };
        }
        if (nextEl) {
          nextEl.onclick = function () {
            if (container._embla) container._embla.scrollNext();
          };
        }

        if (!container._emblaResizeBound) {
          container._emblaResizeBound = true;
          var resizeTimeout;
          window.addEventListener('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
              var nextPerView = applySlideSizing(container, slides);
              var nextLoop = loopSetting === null
                ? (nextPerView ? slides.length > nextPerView : slides.length > 4)
                : loopSetting;
              var nextDragFree = dragFreeSetting === null ? true : dragFreeSetting;

              if (container._embla && (container._emblaLoop !== nextLoop || container._emblaDragFree !== nextDragFree)) {
                try {
                  if (typeof container._embla.destroy === 'function') container._embla.destroy();
                } catch (e) {
                  // no-op
                }
                container._embla = window.EmblaCarousel(viewport, {
                  align: 'start',
                  loop: nextLoop,
                  dragFree: nextDragFree,
                  containScroll: nextLoop ? false : 'trimSnaps',
                  skipSnaps: nextDragFree
                });
                container._emblaLoop = nextLoop;
                container._emblaDragFree = nextDragFree;
                container._emblaPerView = nextPerView;
              } else if (container._embla && typeof container._embla.reInit === 'function') {
                container._embla.reInit();
                container._emblaLoop = nextLoop;
                container._emblaDragFree = nextDragFree;
                container._emblaPerView = nextPerView;
              }
            }, 150);
          });
        }
      });
    };

    window.dAgency.initCarouselBanner(document);

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (!event || !event.target) return;
        window.dAgency.initCarouselBanner(event.target);
      });

      document.addEventListener('shopify:section:select', function (event) {
        if (!event || !event.target) return;
        window.dAgency.initCarouselBanner(event.target);
      });

      document.addEventListener('shopify:block:select', function (event) {
        if (!event || !event.target) return;
        window.dAgency.initCarouselBanner(event.target);
      });
    }
  }

  // Redirect directly to checkout on minicart submit
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('#CartDrawer .cart__link');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    window.location.href = '/checkout';
  });

  // Mega Menu Desktop prev
  // let observerNav = new MutationObserver((mutationsList, observer) => {
  
  //   const tmenu_nav = document.querySelector('.tmenu_nav');
    
  //   if( tmenu_nav ) {      
      
  //     if( ! isMobile ) {

  //       if (observerNav) {
  //         observerNav.disconnect();
  //         observerNav = null;
  //       }
        
  //       // tmenu_nav.classList.remove('tmenu_transition_fade');
  //       // document.querySelector('.tmenu_navbar').classList.remove('tmenu_transition_fade');
        
  //       // Set header white
  //       const mm = tmenu_nav.querySelectorAll('.header__center .sease-mm.tmenu_item_submenu_type_mega');
  //       mm.forEach(m => {

  //         m.addEventListener('mouseenter', function (e) {
  //           document.body.classList.add('mm-active', 'ab-active');
  //         });
          
  //         m.addEventListener('mouseleave', function (e) {

  //           if( document.body.classList.contains('ab-active') ) {
  //             setTimeout(() => {
  //               document.body.classList.remove('ab-active');
  //             }, 300); 
  //           }

  //           const toEl = e.relatedTarget;
  //           if (toEl?.closest('.tmenu_item--root') && !toEl.closest('.sease-mm')) {              
  //             setTimeout(() => {
  //               document.body.classList.remove('ab-active');
  //               document.body.classList.remove('mm-active');
  //             }, 250);
  //           }

  //         });    
  //       });

  //       tmenu_nav.addEventListener('mouseleave', function (e) {

  //         if( document.body.classList.contains('mm-active')) {
  //           setTimeout(() => {
  //             document.body.classList.remove('mm-active');
  //           }, 300);
  //         }
  //       });
  //     }

  //     tmenu_nav.querySelectorAll('a').forEach(link => {
  //       link.addEventListener('mouseenter', function () {
  //         this.setAttribute('data-title', this.getAttribute('title'));
  //         this.removeAttribute('title');
  //       });
  //       link.addEventListener('mouseout', function () {
  //         this.setAttribute('title', this.getAttribute('data-title'));
  //         this.removeAttribute('data-title');
  //       });
  //     });

  //   }
  // });
  // observerNav.observe(document.body, { childList: true, subtree: true });

  // Mega Menu Desktop
  let menuInitialized = false;
  let observerNav = new MutationObserver((mutationsList, observer) => {						
    const tmenu_nav = document.querySelector('.tmenu_nav');
    
    if (tmenu_nav && !isMobile && !menuInitialized) {
      menuInitialized = true;
      
      if (observerNav) {
        observerNav.disconnect();
      }
      
      const mm = tmenu_nav.querySelectorAll('.header__center .sease-mm.tmenu_item_submenu_type_mega');
      
      tmenu_nav.addEventListener('mouseover', function(e) {
        const target = e.target.closest('.header__center .sease-mm.tmenu_item_submenu_type_mega');
        if (target && !document.body.classList.contains('mm-active')) {
          document.body.classList.add('mm-active', 'ab-active');
        }
      }, true);

      tmenu_nav.addEventListener('mouseout', function(e) {
        const relatedTarget = e.relatedTarget;

        // if (!e.relatedTarget || !tmenu_nav.contains(e.relatedTarget)) {
        //  document.body.classList.remove('mm-active', 'ab-active');
        // }
        
        // Don't remove classes if mouse moved to logo, header right, or is still within menu area
        if (!relatedTarget) {
          document.body.classList.remove('mm-active', 'ab-active');
          return;
        }
        
        // Check if moving to logo or header components
        const isMovingToLogo = relatedTarget.closest('.header__left');
        const isMovingToHeaderRight = relatedTarget.closest('.header__right');
        const isStillInMenu = tmenu_nav.contains(relatedTarget);
        
        if (!isStillInMenu && !isMovingToLogo && !isMovingToHeaderRight) {
          document.body.classList.remove('mm-active', 'ab-active');
        }
      }, true);

      // Add mouseenter event for logo to remove menu state
      const logo = document.querySelector('.header__container .logo');
      if (logo) {
        logo.addEventListener('mouseenter', function() {
          document.body.classList.remove('mm-active', 'ab-active');
        });
      }

      tmenu_nav.querySelectorAll('a').forEach(link => {
        link.addEventListener('mouseenter', function() {
          const title = this.getAttribute('title');
          if (title) {
            this.setAttribute('data-title', title);
            this.removeAttribute('title');
          }
        });
        link.addEventListener('mouseout', function() {
          const dataTitle = this.getAttribute('data-title');
          if (dataTitle) {
            this.setAttribute('title', dataTitle);
            this.removeAttribute('data-title');
          }
        });
      });
    }
  });
  observerNav.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: false,
      characterData: false
  });

  // Activate Mobile submemu: watching on .open
  const mobileMenu = document.querySelector(".header__mobile-menu");

  const observerMobileMenu = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.attributeName === "class") {
        if (mobileMenu.classList.contains("open")) {

          const headerMobileMenuFooter = document.querySelector(".header__mobile-menu__footer");
          const headerMobileMenuContainer = document.querySelector(".header__mobile-menu__container");
          
          document.querySelectorAll(".tmenu_item_level_0 .tmenu_item_link").forEach((item, index) => {
            
            item.addEventListener("click", function (e) {
              
              // e.preventDefault();          
              
              let menuItemsL2 = document.querySelectorAll(".sease-mm.tmenu_item_mobile .tmenu_item_level_1.tmenu_item_mobile:first-child .tmenu_item_level_2.tmenu_item_mobile");
              if( menuItemsL2.length ) {
                menuItemsL2.forEach(li => {
                  li.classList.add("tmenu_item_active");
                });
              }
              
              setTimeout(() => {

                const items = document.querySelectorAll(".tmenu_item_level_0");

                let activeItem = document.querySelector(".tmenu_item_level_0.tmenu_item_active");

                if (activeItem) {
                  // hide all except active
                  items.forEach(i => {
                    if (i !== activeItem) {
                      i.classList.add("hide");
                    } else {
                      i.classList.remove("hide"); // keep active visible
                    }
                  });
                  headerMobileMenuFooter.classList.add("hide");
                  headerMobileMenuContainer.classList.add("opened");
                } else {
                  // if none active → show all
                    items.forEach(i => i.classList.remove("hide"));
                    headerMobileMenuFooter.classList.remove("hide");
                    headerMobileMenuContainer.classList.remove("opened");
                }

                let level0 = '';

                if (item.parentElement && item.parentElement.classList.contains('collection')) {
                  level0 = 'collection';
                }
                if (item.parentElement && item.parentElement.classList.contains('tennis')) {
                  level0 = 'tennis';
                }
                if (item.parentElement && item.parentElement.classList.contains('sease-world')) {
                  level0 = 'sease-world';
                }
                if (item.parentElement && item.parentElement.classList.contains('sease-gifts')) {
                  level0 = 'sease-gifts';
                }
                if (item.parentElement && item.parentElement.classList.contains('shop-by-look')) {
                  level0 = 'shop-by-look';
                }
                if (item.parentElement && item.parentElement.classList.contains('amos')) {
                  level0 = 'amos';
                }
                
                let menuItems = document.querySelectorAll(`.tmenu_item_level_0.sease-mm.tmenu_item_mobile.${level0} .tmenu_item_level_1.tmenu_item_mobile`);
                if( menuItems.length ) {
                  
                  const collectionSkipIndexes = [1,2,3];

                  for (let i = 0; i < menuItems.length; i++) {
                    const li = menuItems[i];
                    if( level0 == 'collection' && collectionSkipIndexes.includes(i) ) {
                      continue; // break;
                    }
                    li.classList.add("tmenu_item_active");
                  };                
                }
              }, 0);
            });
          });

        }
      }
    }
  });
  observerMobileMenu.observe(mobileMenu, { attributes: true });

  // Close mobile
  document.addEventListener("click", function(e) {
    
    if (e.target.closest(".header__burger-icon")) {
      document.documentElement.style.overflowY = "hidden";
      document.body.classList.add('header-white');
      document.querySelector('#header-announcement-container').classList.add('mm');
    }
    
    if (e.target.closest(".header__mobile-menu__close-icon")) {
      document.querySelector(".header__mobile-menu")?.classList.remove("open");
      document.documentElement.style.overflowY = "";
      document.querySelector(".header__container")?.classList.add("apply-transparency");
      document.querySelector(".header__container")?.classList.remove("force-opacity");
      if (!document.body.classList.contains('permanent-white')) {
        document.body.classList.remove('header-white');
      }
      window.dispatchEvent(new Event('scroll'));
      document.querySelector('#header-announcement-container').classList.remove('mm');
    }
  });  
});

// Mobile menu slide effect
(() => {
  const container = document.querySelector('.header__mobile-menu__container');
  const menu = document.querySelector('#SeaseMobileMenu');
  if (!container || !menu) return;

  const D = 0.40; // duration
  const EASE = 'cubic-bezier(0.5, 0, 0.5, 1)';

  if (window.gsap && typeof window.gsap.to === 'function') {
    const gsap = window.gsap;

    // Prevent CSS from fighting JS (optional but recommended)
    menu.style.transition = 'none';

    gsap.set(menu, { xPercent: 0, autoAlpha: 1, force3D: true, willChange: 'transform,opacity' });

    let tl = null;
    const kill = () => { gsap.killTweensOf(menu); tl && tl.kill(); };

    // OPEN: right -> place
    const slideInFromRight = () => {
      kill();
      // fromTo with immediateRender to avoid a frame delay
      tl = gsap.fromTo(
        menu,
        { xPercent: 100, autoAlpha: 1 },
        { xPercent: 0, duration: D, ease: EASE, overwrite: 'auto', onComplete: () => menu.removeAttribute('data-animating') }
      );
    };

    // CLOSE: left -> place (plays instantly)
    const slideInFromLeft = () => {
      kill();
      // guard against CSS hide during animation
      menu.setAttribute('data-animating', '');
      tl = gsap.fromTo(
        menu,
        { xPercent: -100, autoAlpha: 1 },
        { xPercent: 0, duration: D, ease: EASE, overwrite: 'auto', onComplete: () => menu.removeAttribute('data-animating') },
      );
    };

    // Track state to know if .opened was added or removed
    let wasOpened = container.classList.contains('opened');

    new MutationObserver(muts => {
      for (const m of muts) {
        if (m.attributeName !== 'class') continue;

        // Check the *old* and current class values to avoid any extra tick
        const oldHadOpened = (m.oldValue || '').split(/\s+/).includes('opened');
        const isOpened = container.classList.contains('opened');

        if (isOpened && !oldHadOpened) {
          // .opened ADDED
          slideInFromRight();
        } else if (!isOpened && oldHadOpened) {
          // .opened REMOVED
          slideInFromLeft();
        }

        wasOpened = isOpened;
      }
    }).observe(container, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });

    return;
  }
})();

// header__container toggle .no-active on mouseenter/leave on it (color of links)
(() => {
  
  const checkActive = () => {
    
    const nav = document.querySelector('.header__container');
    if (!nav) return;
    
    const hasActive = !!document.querySelector('body.sease.template-collection .tmenu_item--root.tmenu_item_level_0.tmenu_item_active');
    nav.classList.toggle('no-active', !hasActive);
  };

  if( ! window.matchMedia("(max-width:1024px)").matches ) {
    const observer_tmenu_nav = new MutationObserver(checkActive);
    observer_tmenu_nav.observe(document.body, { childList: true, subtree: true, attributes: true });
  }
})();

(function () {
  
  // Listen cart empty
  const cartDrawer = document.querySelector('#CartDrawer');
  if (cartDrawer) {
    const observerCartEmpty = new MutationObserver(() => {
      if (document.documentElement.classList.contains('js-drawer-open')) {
        const emptyMsg = cartDrawer.querySelector('.cart--empty-message');
        cartDrawer.classList.toggle('cart-empty', !!emptyMsg);
      }
    });
    observerCartEmpty.observe(cartDrawer, { childList: true, subtree: true });
  }

  function detectCollectionParams() {
    
    const body = document.body;
    body.classList.remove('has-filters');
    
    if (!document.body.classList.contains('template-collection')) return;
    
    const urlParams = new URLSearchParams(window.location.search);
    const hasFilters = Array.from(urlParams.keys()).some(key => 
      key.startsWith('filter.p.m.filter')
    );
    const sortBy = urlParams.get('sort_by');
    const hasCustomSort = sortBy && sortBy !== 'manual';

    if (hasFilters || hasCustomSort) {
      body.classList.add('has-filters');
    }
  }
  detectCollectionParams();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectCollectionParams);
  }
 
  // Traditional events
  window.addEventListener('popstate', detectCollectionParams);
  window.addEventListener('hashchange', detectCollectionParams);

  // History API overrides
  const { pushState, replaceState } = history;
  history.pushState = (...args) => { pushState.apply(history, args); detectCollectionParams(); };
  history.replaceState = (...args) => { replaceState.apply(history, args); detectCollectionParams(); };

  // Modern Navigation API
  if (window.navigation) {
    navigation.addEventListener('navigate', detectCollectionParams);
  }

})();

// Rebuy reinit on minicart
// (function () {

//   // Prevent installing the listener multiple times
//   if (window.__rebuyMinicartListenerInstalled) {
//     console.log('[Rebuy] listener already installed, skipping');
//     return;
//   }
//   window.__rebuyMinicartListenerInstalled = true;

//   // Globals to debounce/throttle reinit
//   window.__rebuyReinitTimeout = null;
//   window.__rebuyLastReinitAt = 0;

//   // Allowed real reinit (ms)
//   const REBUY_REINIT_THROTTLE = 300; // tweak if needed
//   const REBUY_REINIT_DEBOUNCE = 100; // wait after last change

//   function scheduleRebuyReinit(reason) {
//     if (!window.Rebuy) {
//       console.warn('[Rebuy] Rebuy not ready, skip reinit', reason);
//       return;
//     }

//     const now = Date.now();

//     // Throttle: if we already reinit recently, skip
//     if (now - window.__rebuyLastReinitAt < REBUY_REINIT_THROTTLE) {
//       console.log('[Rebuy] reinit throttled, reason:', reason);
//       return;
//     }

//     // Debounce: reset timer so rapid bursts result in ONE call
//     clearTimeout(window.__rebuyReinitTimeout);

//     window.__rebuyReinitTimeout = setTimeout(function () {
//       // Update last reinit timestamp *when we actually call it*
//       window.__rebuyLastReinitAt = Date.now();

//       try {
//         window.Rebuy.reinit();
//         console.log('[Rebuy] reinit from scheduleRebuyReinit, reason:', reason);
//       } catch (err) {
//         console.error('[Rebuy] reinit error', err);
//       }
//     }, REBUY_REINIT_DEBOUNCE);
//   }

//   // Public helper if you still want to call it manually somewhere else
//   window.initRebuyMinicart = function (reason = 'manual') {
//     scheduleRebuyReinit(reason);
//   };

//   document.addEventListener('rebuy:cart.change', function () {
//     console.log('[Rebuy] rebuy:cart.change fired');
//     scheduleRebuyReinit('rebuy:cart.change');
//   });
  
// })();

// Remove mm-active class when moving mouse over first menu item link on desktop
// (function() {
//   // Only apply on desktop
//   if (window.innerWidth < 1025) return;
  
//   let lastRemoved = 0;
//   const throttleMs = 100; // Throttle to prevent excessive calls
  
//   // Use mousemove for continuous detection while hovering
//   document.addEventListener('mousemove', function(e) {
//     // Only proceed if body has mm-active class
//     if (!document.body.classList.contains('mm-active')) return;
    
//     const now = Date.now();
//     if (now - lastRemoved < throttleMs) return;
    
//     const firstMenuItemLink = document.querySelector('.tmenu_item--root.tmenu_item_level_0 > a.tmenu_item_link');
//     if (!firstMenuItemLink) return;
    
//     // Check if mouse is over the first menu item or its children
//     if (e.target === firstMenuItemLink || firstMenuItemLink.contains(e.target)) {
//       lastRemoved = now;
//       document.body.classList.remove('mm-active');
//     }
//   });
// })();

